import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { getProductPerServiceList } from "actions/productActions";

function ProductPerServiceManagementDetails() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const serviceData = location.state?.item;

  const listProductsPerService = useSelector(
    (state) => state.listProductsPerService
  );
  const { productsListPerService } = listProductsPerService;

  useEffect(() => {
    dispatch(getProductPerServiceList(id));
  }, [dispatch, id]);

  const Supplier = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox>
        <MDTypography
          variant="button"
          fontWeight="medium"
          ml={1}
          sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          lineHeight={1}
        >
          {name}
        </MDTypography>
        <MDBox mt={1.5}>
          <MDTypography
            variant="button"
            fontSize="small"
            ml={1}
            lineHeight={1}
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
          >
            {email}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );

  function renderRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        supplier: (
          <Link to={`/products/${item?._id}`}>
            <Supplier
              key={index}
              image={item?.supplier?.supplierLogo}
              name={item?.supplier?.supplierName}
              email={item?.supplier?.supplierEmail}
            />
          </Link>
        ),
        products: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.productName} - {item?.productNumber}
          </MDTypography>
        ),
        amount: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            Ksh. {item?.amount}
          </MDTypography>
        ),
        addons: (
          <MDTypography
            variant="caption"
            sx={{ color: ({ palette: { text, grey } }) => text.darkAccent }}
            fontWeight="medium"
          >
            {item?.addons?.length} items
          </MDTypography>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar title={`${serviceData?.service}'s Products`} />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox pt={3}>
              <DataTable
                table={{
                  columns: [
                    {
                      Header: "supplier",
                      accessor: "supplier",
                      width: "20%",
                      align: "left",
                    },
                    {
                      Header: "products",
                      accessor: "products",
                      width: "20%",
                      align: "left",
                    },

                    {
                      Header: "amount",
                      accessor: "amount",
                      width: "20%",
                      align: "center",
                    },
                    {
                      Header: "addons",
                      accessor: "addons",
                      width: "20%",
                      align: "center",
                    },
                  ],

                  rows: renderRows(productsListPerService),
                }}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default ProductPerServiceManagementDetails;
